import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import vueCustomElement from 'vue-custom-element';
import 'document-register-element/build/document-register-element';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(vueCustomElement);
Vue.use(VueCarousel);
Vue.use(VueAxios, axios);

App.store = store;
App.router = router;
Vue.customElement('tour-widget', App);
